// Fixed 4-platform form (no add/remove rows) for PreflightSettings.issue_dates
// - the Note issue date per platform, shown on that platform's Report
// factsheet. Not derivable from LoanTape/CashFlows, a plain settings input.
// Ports reporting-hub's IssueDatesForm.tsx.

import React from 'react';
import { Calendar } from 'primereact/calendar';
import { PLATFORM_ORDER, titleCasePlatform, isoToDate, dateToIso } from './calcFormat';

const IssueDatesForm = ({ values, onChange }) => {
  const updatePlatform = (platform, isoDate) => {
    onChange({ ...values, [platform]: isoDate });
  };

  return (
    <div className="cr-table-frame" style={{ maxWidth: '20rem' }}>
      <table className="cr-data-table cr-form-table">
        <thead>
          <tr>
            <th>Originator</th>
            <th className="cr-right">Issue Date</th>
          </tr>
        </thead>
        <tbody>
          {PLATFORM_ORDER.map((platform) => (
            <tr key={platform}>
              <td>{titleCasePlatform(platform)}</td>
              <td className="cr-right">
                <Calendar
                  value={isoToDate(values[platform])}
                  onChange={(e) => updatePlatform(platform, dateToIso(e.value))}
                  dateFormat="dd/mm/yy"
                  showIcon
                  inputStyle={{ width: '9rem', fontSize: '0.82rem' }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IssueDatesForm;
